import firebase from 'firebase'
import 'firebase/firestore'
const config = require('./firebaseSecret.js')

firebase.initializeApp(config.config)

// firebase utils
const db = firebase.firestore()
const auth = firebase.auth()
const currentUser = auth.currentUser

// date issue fix according to firebase
const settings = {
    //timestampsInSnapshots: true
}
db.settings(settings)

// firebase collections
const usersCollection = db.collection('users')
const boxesCollection = db.collection('boxes')


export {
    db,
    auth,
    currentUser,
    usersCollection,
    boxesCollection,
}



// WEBPACK FOOTER //
// ./src/firebaseConfig.js